import { fork, put, select, takeEvery } from "redux-saga/effects";

import ApiClient from "../../../api/ApiClient";
import { fetchStaticPageRedirectsRoutine } from "./index";
import { getStaticPageRedirectsForLocale } from "./selector";
import { getLocale } from "../translations/selector";

function* onFetchStaticPageRedirects({ payload } = {}) {
  const locale = payload?.locale || (yield select(getLocale));
  const cachedMappings = yield select(getStaticPageRedirectsForLocale, locale);

  if (Array.isArray(cachedMappings)) {
    yield put(
      fetchStaticPageRedirectsRoutine.success({
        locale,
        mappings: cachedMappings
      })
    );
    return;
  }

  try {
    const { data } = yield ApiClient.get({
      urlPath: "app.staticPages.redirects",
      skipAccessCheck: true,
      skipAuthorizationHeader: true
    });

    yield put(
      fetchStaticPageRedirectsRoutine.success({
        locale,
        mappings: Array.isArray(data) ? data : []
      })
    );
  } catch (e) {
    // Fail open so guest navigation is not blocked on API errors.
    yield put(
      fetchStaticPageRedirectsRoutine.success({
        locale,
        mappings: []
      })
    );
  }
}

function* watchFetchStaticPageRedirects() {
  yield takeEvery(
    fetchStaticPageRedirectsRoutine.TRIGGER,
    onFetchStaticPageRedirects
  );
}

export default [fork(watchFetchStaticPageRedirects)];
